module.exports = __webpack_public_path__ + "img/cyber-planet.eb2aa455.png";